import main from './main'
import massive from './massive'
import crm from '../slices/crm'
import report from '../slices/report'
import {combineReducers} from 'redux'

const rootReducer = combineReducers({massive, main, crm, report})


export default rootReducer;